import React, { useEffect } from 'react';

/**
 * SPA-level "RSS shim" — visiting /blog/rss.xml sends browsers/feed-readers
 * to the actual RSS feed served by the backend at /api/blog/rss.xml.
 * A <meta http-equiv="refresh"> is added so crawlers/feed-readers that
 * don't run JS still follow the redirect.
 */
export default function RssRedirect() {
  const target = `${process.env.REACT_APP_BACKEND_URL || ''}/api/blog/rss.xml`;

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <>
      <meta httpEquiv="refresh" content={`0; url=${target}`} />
      <link rel="alternate" type="application/rss+xml" title="Bison Blog RSS" href={target} />
      <div style={{ padding: 40, fontFamily: 'Georgia, serif' }}>
        <h1>Bison Blog RSS Feed</h1>
        <p>
          Redirecting to <a href={target}>{target}</a>…
        </p>
      </div>
    </>
  );
}
